import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ConfirmModal({ title, bodyText, show, setShow, handleClose, onClickHandle }) {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="sm"
        className='confirm-modal'
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          <button type="button" className="btn-close-custom" aria-label="Close" onClick={handleClose}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          {bodyText}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => onClickHandle(true)}>Clear Basket</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmModal;